import { localeDefinitions, normalizeLocale } from '../../i18n/locales';

export interface CreditUnitMetadata {
  credit_unit_mode?: 'dobi' | string;
  unit_key?: string;
  unit_label_zh?: string;
  unit_label_en?: string;
  scale?: number;
  credits_per_image?: number;
  credit_unit?: CreditUnitMetadata | null;
}

export const dobiCreditUnitFallback: Required<Omit<CreditUnitMetadata, 'credit_unit'>> = {
  credit_unit_mode: 'dobi',
  unit_key: 'dobi_coin',
  unit_label_zh: 'DOBI币',
  unit_label_en: 'DOBI coins',
  scale: 12,
  credits_per_image: 72,
};

export function normalizeCreditUnitMetadata(metadata?: CreditUnitMetadata | null): Required<Omit<CreditUnitMetadata, 'credit_unit'>> {
  void metadata;
  return {
    credit_unit_mode: dobiCreditUnitFallback.credit_unit_mode,
    unit_key: dobiCreditUnitFallback.unit_key,
    unit_label_zh: dobiCreditUnitFallback.unit_label_zh,
    unit_label_en: dobiCreditUnitFallback.unit_label_en,
    scale: dobiCreditUnitFallback.scale,
    credits_per_image: dobiCreditUnitFallback.credits_per_image,
  };
}

export function getCreditUnitLabel(metadata: CreditUnitMetadata | null | undefined, locale?: string): string {
  const unit = normalizeCreditUnitMetadata(metadata);
  const language = normalizeLocale(locale);
  if (language === 'zh') return unit.unit_label_zh;
  if (language === 'en') return unit.unit_label_en;
  return localeDefinitions[language].creditUnit;
}

export function getCreditsPerImage(metadata?: CreditUnitMetadata | null): number {
  return Math.max(normalizeCreditUnitMetadata(metadata).credits_per_image, 1);
}

export function replaceCreditUnitLabel(
  text: string,
  metadata: CreditUnitMetadata | null | undefined,
  locale?: string,
): string {
  const unitLabel = getCreditUnitLabel(metadata, locale);
  return text.replace(/__UNIT__|'\{unit\}'|\{unit\}|DOBI币|DOBI coins?/g, unitLabel);
}
